import { useTranslation } from 'react-i18next';
import { Divider } from '@components/divider';

import { BackButton } from './components/back-button';
import { CompanyHeader } from './components/company-header';
import { CountryInputSkeleton } from './components/country-input-skeleton';
import { FooterButtonsSkeleton } from './components/footer-buttons-skeleton';
import { InputFieldSkeleton } from './components/input-field-skeleton';
import { PhoneNumberSkeleton } from './components/phone-number-skeleton';
import { TextareaSkeleton } from './components/textarea-skeleton';
import { VatNumberSkeleton } from './components/vat-number-skeleton';
import { VatRadioSkeleton } from './components/vat-radio-skeleton';
import { WarningCard } from './components/warning-card';

export const InfoSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className='px-4 md:px-0'>
      <div className='flex justify-center'>
        <div className='w-full md:w-[850px]'>
          <button className='rounded-full w-max mb-4 md:mb-6' type='button' aria-label='Menu'>
            <BackButton />
          </button>
        </div>
      </div>
      <div className='flex justify-center'>
        <div className='flex justify-start w-full max-w-[630px] flex-col mb-5 md:mb-40'>
          <form className='relative'>
            <CompanyHeader />
            <WarningCard />
            <section>
              <h2 className='text-headline-m text-primary pb-6'>{t('companySettings:publicNameSectionTitle')}</h2>
              <div className='grid items-start mb-4 sm:mb-8 grid-cols-1 gap-4'>
                <InputFieldSkeleton label={t('companySettings:publicNameLabel')} htmlFor='publicName' />
                <TextareaSkeleton
                  label={t('companySettings:customerSupportEmailsLabel')}
                  htmlFor='customerSupportEmails'
                  helperText={t('companySettings:customerSupportEmailsHelperText')}
                />
              </div>
              <Divider className='my-10' />
            </section>
            <section>
              <h2 className='text-headline-m text-primary pb-6'>{t('companySettings:billingSectionTitle')}</h2>
              <div className='grid items-start mb-4 sm:mb-8 grid-cols-1 gap-4'>
                <VatRadioSkeleton />
                <InputFieldSkeleton label={t('companySettings:businessNameLabel')} htmlFor='billingInfo.legalName' />
                <InputFieldSkeleton label={t('companySettings:addressLabel')} htmlFor='billingInfo.registeredAddress' />
                <InputFieldSkeleton label={t('companySettings:postcodeLabel')} htmlFor='billingInfo.postcode' />
                <InputFieldSkeleton label={t('companySettings:cityLabel')} htmlFor='billingInfo.city' />
                <CountryInputSkeleton />
                <VatNumberSkeleton />
              </div>
              <Divider className='my-10' />
            </section>
            <section>
              <h2 className='text-headline-m text-primary pb-6'>{t('companySettings:bankSectionTitle')}</h2>
              <div className='grid items-start mb-4 sm:mb-8 grid-cols-1 gap-4'>
                <InputFieldSkeleton
                  label={t('companySettings:accountHolderNameLabel')}
                  htmlFor='billingInfo.legalName'
                />
                <CountryInputSkeleton />
                <InputFieldSkeleton label={t('companySettings:ibanLabel')} htmlFor='bankingDetails.bankNumber' />
                <InputFieldSkeleton label={t('companySettings:bicLabel')} htmlFor='bankingDetails.bankCode' />
              </div>
              <Divider className='my-10' />
            </section>
            <section>
              <h2 className='text-headline-m text-primary pb-6'>{t('companySettings:notificationSectionTitle')}</h2>
              <div className='grid items-start mb-4 sm:mb-8 grid-cols-1 gap-4'>
                <PhoneNumberSkeleton />
                <TextareaSkeleton
                  label={t('companySettings:emailsLabel')}
                  htmlFor='financeNotifications.emails'
                  helperText={t('companySettings:multiEmailHintText')}
                />
              </div>
            </section>
            <FooterButtonsSkeleton />
          </form>
        </div>
      </div>
    </div>
  );
};
